import * as React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import {Box,Paper} from '@mui/material';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';


export function LoadingSection(props) {
  const { loading = false } = props;

  return (
    <Paper>
            <Skeleton variant="rectangular" width={"50%"} height={118} />
            <Box sx={{ pt: 0.5 }}>
              <Skeleton />
              <Skeleton width="100%" />
              <Skeleton width="100%" />
            <Skeleton variant="rectangular" width={"50%"} height={90} />
              <Skeleton width="100%" />
              <Skeleton width="100%" />
            </Box>
    </Paper>
  );
}

LoadingSection.propTypes = {
  loading: PropTypes.bool,
};

export default function LoadingPage() {
  return (
    <Box sx={{ overflow: 'hidden' }}>
      <LoadingSection loading />
      <LoadingSection />
    </Box>
  );
}